$(document).on("click", ".addreses_button", function () {
  $(this).parent().find(".edit-address-button").trigger("click");
});

let cartAutoCloseTimer = null;
function startCartAutoClose(drawer) {
    clearTimeout(cartAutoCloseTimer);
    cartAutoCloseTimer = setTimeout(() => {
        document.body.classList.remove('open-cc', 'open-cart');
        drawer?.classList.remove('active');
    }, 3500);
}
function stopCartAutoClose() {
    clearTimeout(cartAutoCloseTimer);
}
$(document).on('click', '.size-option-btn', function () {
    var vid = parseInt($(this).attr('data-variant-id'));
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            quantity: 1,
            id: vid
        },
        dataType: 'json',
        success: function (response) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            const drawer = document.querySelector('cart-drawer');
            document.body.classList.add('open-cc', 'open-cart');
            drawer?.classList.add('active');
            if (!drawer) return;
            drawer.dataset.userInteracted = 'false';
            startCartAutoClose(drawer);
            if (!drawer.dataset.autocloseBound) {
                const stopForever = () => {
                    if (drawer.dataset.userInteracted === 'false') {
                        drawer.dataset.userInteracted = 'true';
                        stopCartAutoClose();
                    }
                };
                drawer.addEventListener('touchstart', stopForever, { passive: true });
                drawer.addEventListener('touchmove', stopForever, { passive: true });
                drawer.addEventListener('scroll', stopForever, { passive: true });
                drawer.addEventListener('click', stopForever);
                drawer.addEventListener('mouseenter', stopForever);
                drawer.dataset.autocloseBound = 'true';
            }
        }
    });
});

$(document).on("click", ".side-panel-close-custom", function () {
  $("#side-panel-search-input").val("");
  $(".side-panel-content--has-tabs").removeClass("active");
});
$(document).on("click", ".custom_minus_button", function () {
  let removeButton = $(this).parent().parent().parent().find(".remove");

  if (removeButton.length) {
    removeButton[0].dispatchEvent(new Event("click", { bubbles: true }));
  }
});
setInterval(function () {
  const buttons = document.querySelectorAll(".single-add-to-cart-button--text");
  for (let i = 0; i < buttons.length; i++) {
    const button = buttons[i];
    const html = button.innerHTML.trim().toLowerCase();
    if (html === "sold out" || html === "coming soon") {
      button.parentNode.classList.add("soldout_button");
    } else {
      button.parentNode.classList.remove("soldout_button");
    }
  }
});
document.addEventListener("click", function (event) {
  if (event.target.closest(".iwish-row.iwishProduct-row")) {
    let productLink = event.target
      .closest(".iwish-row.iwishProduct-row")
      .querySelector(".product-title a");
    if (productLink) {
      productLink.click();
    }
  }
});

$(document).ready(function () {
  setTimeout(function () {
    $(".iwish-float-icon").trigger("click");
  }, 500);
  setTimeout(function () {
    var cartContent = $("body").find(".iwish-drawer-menu .drawer-body").html();
    $(".append_items_in").html(cartContent);
    console.log(cartContent);
    $(".iwish-row.iwish-prouctImg img").each(function () {
      var img = $(this);
      var src = img.attr("src");

      if (src.includes("x400")) {
        var newSrc = src.replace("x400", "x1024");
        img.attr("src", newSrc);
      }
    });
  }, 2500);
});

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const klarnaPlacement = document.querySelector("klarna-placement");

    if (klarnaPlacement && klarnaPlacement.shadowRoot) {
      const container = klarnaPlacement.shadowRoot.querySelector(".container.auto-size");

      if (container && !klarnaPlacement.classList.contains("styled")) {
        container.style.border = "unset";
        container.style.padding = "0px";
        container.style.textAlign = "left";

        const logo = container.querySelector(".logo");
        if (logo) {
          logo.style.fontSize = "13px";
        }

        klarnaPlacement.style.marginTop = "-7px";
        klarnaPlacement.style.display = "block";
        klarnaPlacement.classList.add("styled");

        const klarnaParent = klarnaPlacement.parentElement;
        if (klarnaParent && !klarnaParent.classList.contains("moved-klarna")) {
          const cloned = klarnaParent.cloneNode(true);
          cloned.classList.add("moved-klarna");
          klarnaParent.remove();

          const pickupAvailability = document.querySelector("pickup-availability");
          if (pickupAvailability) {
            pickupAvailability.parentNode.insertBefore(cloned, pickupAvailability);

            setTimeout(() => {
              const newKlarna = cloned.querySelector("klarna-placement");
              if (newKlarna && newKlarna.shadowRoot) {
                const newContainer = newKlarna.shadowRoot.querySelector(".container.auto-size");
                if (newContainer) {
                  newContainer.style.border = "unset";
                  newContainer.style.padding = "0px";
                  newContainer.style.textAlign = "left";

                  const newLogo = newContainer.querySelector(".logo");
                  if (newLogo) {
                    newLogo.style.fontSize = "13px";
                  }

                  newKlarna.style.marginTop = "-7px";
                  newKlarna.style.display = "block";
                }
              }
            }, 300); 
          }

          clearInterval(interval);
        }
      }
    }
  }, 300);
});



$(document).ready(function () {
  var item_product_title = $(".product-title-container h1").html();
  var item_product_color = $(
    ".variations .product-form__input--siblings label.active a"
  ).attr("title");
  var item_product_size = $(
    ".variations .product-form__input--block input[type=radio]:checked+label span"
  ).html();
  $(".item_product_title").html(item_product_title);
  $(".item_product_color").html(item_product_color);
  $(".item_product_size").html(item_product_size);
  $(".unavailable_pickup.custom_pickup_text").removeClass("custom_pickup_text");
  setTimeout(function(){
    $('.main_template #product_selected_or_first_available_variant_id').attr('value','');
    $('.main_size_selector_div input[checked]').removeAttr('checked');
    $('.product-information').addClass('variations_loaded');
  },600)
});
$(document).on("click", ".custom_pickup_button", function () {
  $(this).parent().find(".hidden_text").removeClass("hidden_text");
   $('body').find("#cookie_styles").remove();
});

$(document).on("click", ".actual_button", function () {
  $('body').find("#cookie_styles").remove();
});

$(document).on(
  'click',
  '.product-drawer .variations_loaded .variations .product-form__input--block input[type=radio]:not(.is-disabled)',
  function () {
      let label = $(this).next('label');
      setTimeout(function(){
        $(label).parent().parent().parent().parent().parent().parent().find('button.single-add-to-cart-button').removeAttr('disabled');
      },100)
      setTimeout(function(){
        $(label).parent().parent().parent().parent().parent().parent().find('button.single-add-to-cart-button').trigger('click');
          console.log('clicked')
      },400)
  }
);


function adjustHeaderPosition() {
  var $bar = $('#bmsm-stickyannouncementbar');
  var $header = $('.header-section');

  if ($bar.length) {
    var barHeight = $bar.outerHeight();
    $header.css('top', barHeight + 'px');
  } else {
    $header.css('top', '');
  }
}
$(window).on('load scroll resize', adjustHeaderPosition);
adjustHeaderPosition();



$(document).on('click','.pickup-notification-close',function(){
    $('.pickup_notification').hide()
})

document.addEventListener('DOMContentLoaded', function () {
  function checkApplePay() {
    const acceleratedCart = document.querySelector('shopify-accelerated-checkout-cart');
    if (!acceleratedCart) return;

    const applePayBtn = acceleratedCart.querySelector('shopify-apple-pay-button');
    const additionalButtons = document.querySelector('.additional-checkout-buttons');

    if (applePayBtn && additionalButtons) {
      additionalButtons.classList.add('apple-pay-full-width');
    }
  }

  checkApplePay();

  const observer = new MutationObserver(checkApplePay);
  observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener('DOMContentLoaded', function () {

  function checkApplePay() {
    const applePayBtn = document.querySelector('shopify-accelerated-checkout-cart shopify-apple-pay-button');
    const target = document.querySelector('.cart-items tfoot .thb-cart-form--cart-collaterals .additional-checkout-buttons');

    if (!target) return;

    if (!applePayBtn) {
      target.classList.add('no-apple-pay');
    } else {
      target.classList.remove('no-apple-pay');
    }
  }

  setTimeout(checkApplePay, 300);
  setTimeout(checkApplePay, 800);
  setTimeout(checkApplePay, 1500);

});



(function() {
    function initSizeSelector(container) {
        const productCards = container.querySelectorAll('product-card');
        
        productCards.forEach(card => {
            const sizeSelector = card.querySelector('.product-card-size-selector');
            if (!sizeSelector) return;
            
            if (sizeSelector.dataset.initialized === 'true') return;
            sizeSelector.dataset.initialized = 'true';
            
            const sizeList = sizeSelector.querySelector('.size-options-list');
            const prevBtn = sizeSelector.querySelector('.size-nav-prev');
            const nextBtn = sizeSelector.querySelector('.size-nav-next');
            const sizeBtns = sizeSelector.querySelectorAll('.size-option-btn');
            const totalSizes = sizeList ? parseInt(sizeList.dataset.totalSizes) || sizeBtns.length : sizeBtns.length;
            
            if (totalSizes > 4 && prevBtn && nextBtn && sizeList) {
                const scrollAmount = 200;
                
                const updateButtons = () => {
                    if (!sizeList) return;
                    const scrollLeft = sizeList.scrollLeft;
                    const maxScroll = sizeList.scrollWidth - sizeList.clientWidth;
                    prevBtn.disabled = scrollLeft <= 5;
                    nextBtn.disabled = maxScroll - scrollLeft <= 5;
                };
                
                const newPrevBtn = prevBtn.cloneNode(true);
                const newNextBtn = nextBtn.cloneNode(true);
                prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
                nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
                
                newPrevBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    sizeList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                    setTimeout(updateButtons, 300);
                });
                
                newNextBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    sizeList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                    setTimeout(updateButtons, 300);
                });
                
                sizeList.addEventListener('scroll', updateButtons);
                updateButtons();
            } else if (prevBtn && nextBtn) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
            }
        });
    }
    
    function initializeAll() {
        initSizeSelector(document);
    }
    
    function setupMutationObserver() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) {
                            if (node.matches && node.matches('product-card')) {
                                initSizeSelector(node.parentNode);
                            } else if (node.querySelectorAll) {
                                const productCards = node.querySelectorAll('product-card');
                                if (productCards.length) {
                                    initSizeSelector(node);
                                }
                            }
                        }
                    });
                }
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        return observer;
    }
    
    function setupShopifyEvents() {
        document.addEventListener('shopify:section:load', (event) => {
            if (event.detail && event.detail.section) {
                initSizeSelector(event.detail.section);
            }
        });
        
        document.addEventListener('shopify:block:select', (event) => {
            if (event.detail && event.detail.section) {
                initSizeSelector(event.detail.section);
            }
        });
        
        document.addEventListener('ajax:success', (event) => {
            initSizeSelector(document);
        });
        
        document.addEventListener('collection:updated', () => {
            initSizeSelector(document);
        });
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initializeAll();
            setupMutationObserver();
            setupShopifyEvents();
        });
    } else {
        initializeAll();
        setupMutationObserver();
        setupShopifyEvents();
    }
    
    document.body.addEventListener('click', (e) => {
        const filterElement = e.target.closest('.filter-group, .filter, .facet-checkbox, .facet-link, .collection-filters button, [data-filter]');
        if (filterElement) {
            setTimeout(() => {
                initSizeSelector(document);
            }, 500);
        }
    });
})();

document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('view') === 'Size_Chart') {
        setTimeout(() => {
            const chartTrigger = document.querySelector('#ProductPopup-variant_picker');
            if (chartTrigger) {
                chartTrigger.click();
                urlParams.delete('view');
                const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
                window.history.replaceState(null, '', newUrl);
            }
        }, 100); 
    }
});




const state = {
  corsets: 'in',
  tops: 'in',
  dresses: 'in',
  pants: 'in',
  skirts: 'in'
};

function setUnit(category, unit) {
  state[category] = unit;
  const table = document.getElementById('table-' + category);
  const cat = document.getElementById('cat-' + category);

  if (!table || !cat) return; 

  const btns = cat.querySelectorAll('.toggle-btn');

  if (unit === 'cm') {
    table.classList.add('showing-cm');
  } else {
    table.classList.remove('showing-cm');
  }

  btns[0].classList.toggle('active', unit === 'in');
  btns[1].classList.toggle('active', unit === 'cm');
}

document.addEventListener('DOMContentLoaded', () => {
  Object.keys(state).forEach(category => {
    setUnit(category, state[category]);
  });

  Object.keys(state).forEach(category => {
    const cat = document.getElementById('cat-' + category);
    if (!cat) return;
    const btns = cat.querySelectorAll('.toggle-btn');
    if (btns.length < 2) return;

    btns[0].addEventListener('click', () => setUnit(category, 'in'));
    btns[1].addEventListener('click', () => setUnit(category, 'cm'));
  });
});

document.addEventListener('popupOpened', () => {
  Object.keys(state).forEach(category => {
    setUnit(category, state[category]);
  });
});



// Stoq Preorder Products

(function() {
  const interval = setInterval(function() {
    const button = document.querySelector('.single-add-to-cart-button.restock-rocket-preorder-button');
    const sizeContainer = document.querySelector('.main_size_selector_div');
    
    if (button && sizeContainer) {
      clearInterval(interval);
      console.log('[Size Watcher] Found button and size container');
      
      const pickupWrapper = document.querySelector('.pickup-availability-wrapper');
      if (pickupWrapper) {
        pickupWrapper.style.display = 'none';
        console.log('[Size Watcher] Hidden .pickup-availability-wrapper');
        
        const hideObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (pickupWrapper.style.display !== 'none') {
              pickupWrapper.style.display = 'none';
              console.log('[Size Watcher] Re-hid .pickup-availability-wrapper');
            }
          });
        });
        hideObserver.observe(pickupWrapper, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      } else {
        const bodyObserver = new MutationObserver(function(mutations, obs) {
          const wrapper = document.querySelector('.pickup-availability-wrapper');
          if (wrapper) {
            wrapper.style.display = 'none';
            console.log('[Size Watcher] Found and hidden .pickup-availability-wrapper');
            const hideObs = new MutationObserver(function() {
              if (wrapper.style.display !== 'none') wrapper.style.display = 'none';
            });
            hideObs.observe(wrapper, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
            obs.disconnect(); 
          }
        });
        bodyObserver.observe(document.body, { childList: true, subtree: true });
      }
      
      const originalText = button.textContent.trim();
      let isSizeSelected = false;
      
      function getSizeInputs() {
        return sizeContainer.querySelectorAll('input');
      }
      
      function updateButton() {
        const inputs = getSizeInputs();
        const anyChecked = Array.from(inputs).some(input => input.checked);
        isSizeSelected = anyChecked;
        
        if (anyChecked) {
          button.disabled = false;
          button.setAttribute('style', 
            'background-color: #000 !important; ' +
            'color: #fff !important; ' +
            '-webkit-text-fill-color: #fff !important;'
          );
          if (button.textContent !== 'Add To Bag') {
            button.textContent = 'Add To Bag';
            console.log('[Size Watcher] Enabled, text → "Add To Bag", styles applied');
          }
        } else {
          button.disabled = true;
          button.removeAttribute('style');
          if (button.textContent !== originalText) {
            button.textContent = originalText;
            console.log('[Size Watcher] Disabled, text → original, styles removed');
          }
        }
      }
      
      function bindListeners() {
        const inputs = getSizeInputs();
        inputs.forEach(input => {
          if (!input.hasAttribute('data-size-watcher')) {
            input.addEventListener('change', updateButton);
            input.addEventListener('click', updateButton);
            input.setAttribute('data-size-watcher', 'true');
          }
        });
      }
      
      const observer = new MutationObserver(function() {
        bindListeners();
        updateButton(); 
      });
      observer.observe(sizeContainer, { childList: true, subtree: true });
      
      bindListeners();
      updateButton(); 
      
      const buttonObserver = new MutationObserver(function() {
        if (isSizeSelected && button.textContent !== 'Add To Bag') {
          button.textContent = 'Add To Bag';
        }
        if (!isSizeSelected && button.textContent !== originalText) {
          button.textContent = originalText;
        }
      });
      buttonObserver.observe(button, { childList: true, characterData: true, subtree: true });
    }
  }, 300);
})();



(function () {
  let attempts = 0;
  const maxAttempts = 40;

  const interval = setInterval(function () {
    attempts++;

    const srLink = document.querySelector(
      'a[data-acsb="sr-trigger"][data-acsb-sr-only="true"]'
    );

    const header = document.querySelector('#main-content');

    if (srLink && header) {
      header.prepend(srLink);

      clearInterval(interval);
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(interval);
    }
  }, 500);
})();

 (function () {
    function removeUnknownInputs() {
      document.querySelectorAll('input[aria-label="UNKNOWN"]').forEach(function (input) {
        input.remove();
      });
    }

    removeUnknownInputs();

    new MutationObserver(removeUnknownInputs).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  })();

document.addEventListener('DOMContentLoaded', function () {
  document
    .querySelectorAll('.template-collection .rich-text .rich-text__inner h3, .template-page .rich-text .rich-text__inner h3')
    .forEach(function (h3) {
      var h1 = document.createElement('h1');

      Array.from(h3.attributes).forEach(function (attr) {
        h1.setAttribute(attr.name, attr.value);
      });

      h1.innerHTML = h3.innerHTML;
      h3.replaceWith(h1);
    });
    
    document
    .querySelectorAll('.template_page-contact .section-footer .signup-container #contact_form')
    .forEach(function (form) {
      form.id = 'contact_form_footer';
    });

    document
    .querySelectorAll('.template-page main.Polaris-Frame__Main')
    .forEach(function (main) {
      var div = document.createElement('div');

      Array.from(main.attributes).forEach(function (attr) {
        div.setAttribute(attr.name, attr.value);
      });

      div.innerHTML = main.innerHTML;
      main.replaceWith(div);
    });
    document
    .querySelectorAll('.template-collection .section-multicolumn .multicolumn__column h4')
    .forEach(function (h4) {
      var span = document.createElement('span');

      Array.from(h4.attributes).forEach(function (attr) {
        span.setAttribute(attr.name, attr.value);
      });

      span.innerHTML = h4.innerHTML;
      h4.replaceWith(span);
    });
});

function initComplementaryProducts() {
  if (window.innerWidth < 768) return;

  document.querySelectorAll('.complementary-products--inner').forEach(function (section) {
    if (section.dataset.sliderInitialized) return;

    var wrapper = section.querySelector('.complementry_products_wrapper');
    var prev = section.querySelector('.complementary-products--prev');
    var next = section.querySelector('.complementary-products--next');

    if (!wrapper || !prev || !next) return;

    section.dataset.sliderInitialized = 'true';

    next.addEventListener('click', function () {
      wrapper.scrollBy({
        left: wrapper.clientWidth / 2,
        behavior: 'smooth'
      });
    });

    prev.addEventListener('click', function () {
      wrapper.scrollBy({
        left: -(wrapper.clientWidth / 2),
        behavior: 'smooth'
      });
    });
  });
}

initComplementaryProducts();

new MutationObserver(function () {
  initComplementaryProducts();
}).observe(document.body, {
  childList: true,
  subtree: true
});
